import React, { useState, useEffect, useRef, useCallback } from "react";
import InView from "react-intersection-observer";
import Slider from 'react-slick';
import { motion } from "framer-motion";
import { SlideInWithScroll } from "../common/utils/animations/slideInWithScroll";
import { Link } from "gatsby";

export default function ThreeColSlider(props) {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [elementTop, setElementTop] = useState((ref.current && props.isLoaded) ? ref.current.offsetTop : 0);
  const [clientHeight, setClientHeight] = useState(0);
  const [clientWidth, setClientWidth] = useState(0);
  let triggers = [[0.70, 0.50], [0.60, 0.30], [0.45, 0.25], [0.35, 0.15], [0.25, 0.05], [0.15, 0]];
  if (props.location.includes("mobile") || props.location.includes("web")) {
    triggers = [[0.75, 0.60], [0.65, 0.50], [0.55, 0.40], [0.45, 0.30], [0.35, 0.20], [0.25, 0.10]];
  }
  if (props.id === "digital-product-3col-slider")
    triggers = [[0.70, 0.65], [0.60, 0.55], [0.50, 0.45], [0.40, 0.35], [0.30, 0.15], [0.20, 0.05]];
  //triggers = [[0.65, 0.50], [0.55, 0.40], [0.40, 0.25], [0.30, 0.15], [0.15, 0], [0.10, 0]];

  if (clientWidth < 1681) {
    triggers.map((t, i) => {
      t[0] += 0.05;
      t[1] += 0.05;
    }
    );
  }
  const setValues = () => {
    setClientHeight(window.innerHeight);
    setClientWidth(window.innerWidth);
    if (!ref.current) return;
    setElementTop(ref.current.offsetTop);
  };

  useEffect(() => {
    setClientWidth(window.innerWidth);
    if (!ref.current) return;
    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  const { header, content, items, classes } = props.data;
  return (
    <div className={`three-col-slider-section section-gap-large ${classes}`} ref={ref} id={props.id} onLoad={setValues}>
      <div className="container">
        <InView onChange={inView => setIsVisible(inView)}>
          <div className="three-col-slider-title">
            <div className="slider-title-inner">
              {/*<p className="theme-color-title">{isVisible && <HeaderAnim header={header} />}</p>*/}
              <h2 className="h2">{header}</h2>
              <p>{content}</p>
            </div>
          </div>
        </InView>
        <div className="three-col-slider-block">
          <div className="row three-col-slider-list d-flex flex-wrap">
            {(clientWidth > 767) && <>
              {/* <Slider {...settings}> */}
              {items.map((item, index) => {
                const jsx = (<motion.div key={index} className="col three-col-slider-item">
                  <div className="slider-item-inner d-flex">
                    <div className="grid-icon">
                      <i>
                        {item.icon}
                      </i>
                    </div>
                    <div className="grid-content">
                      {
                        item.link ? <Link to={item.link}><p className="theme-color-title">{item.subHeader}</p></Link> : <p className="theme-color-title">{item.subHeader}</p>
                      }
                      <h4 className="h6">{item.header}</h4>
                      <p>{item.content}</p>
                    </div>
                  </div>
                </motion.div>);

                return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={triggers[index]} key={index} />;
              })}
              {/* </Slider> */}
            </>}
            {(clientWidth <= 767) && <>
              <Slider {...settings}>
                {items.map((item, index) => {
                  return (<div key={index} className="col three-col-slider-item">
                    <div className="slider-item-inner d-flex">
                      <div className="grid-icon">
                        <i>
                          {item.icon}
                        </i>
                      </div>
                      <div className="grid-content">
                        <p className="theme-color-title">{item.subHeader}</p>
                        <h4 className="h6">{item.header}</h4>
                        <p>{item.content}</p>
                      </div>
                    </div>
                  </div>);
                })}
              </Slider>
            </>}
          </div>
        </div>
      </div>
    </div >
  );
}